import React, { Component } from 'react';
import * as mat from 'material-ui';
import Logo from '../images/Logoaa.jpg'
import single from '../images/single.png'
import multi from '../images/multi.png'
import { connect } from 'react-redux';
import './style.css'
import { singlePlayerAction,teamPlayersAction } from '../../action/playAction'

class PlayOptions extends Component {

    soloClick() {
        let nodeKey = this.props.quizTitle;
        this.props.singlePlayerAction(nodeKey)
        // alert("Under Working")
    }
    teamClick(){
        let nodeKey = this.props.quizTitle;
        this.props.teamPlayersAction(nodeKey)
    }
    render() {
        const {
            quizTitle
        } = this.props;
        return (
            <div >
                <mat.Card
                    zDepth={0}
                    className='col-md-6 col-md-offset-3 col-xs-10 col-xs-offset-1'
                >
                    <div className="page-header text-center">
                        <img src={Logo} alt="Logo" style={{width: '50%'}}/>
                    </div>
                    <mat.Card className='text-center' zDepth={1} style={{ padding: '2.5%' }}>
                        <p style={{ fontSize: '4.2vh', fontFamily: 'cursive', fontWeight: 'bold' }}>{quizTitle}</p>
                    </mat.Card>
                    <br />
                    {/* <div className='col-md-12'> */}
                    <div className='row'>
                        <div className='col-md-6 text-center box1' >
                            <mat.Card zDepth={1} >
                                <mat.Avatar
                                    src={single}
                                    size={140}
                                    backgroundColor={'#ffffff'}
                                    className='options'
                                />
                                <div className="page-header text-center">
                                    <p style={{ fontSize: '3vh', fontFamily: 'arial', fontWeight: 'bold', color: '#abb8c3' }}>Player vs Player <br />
                                        1:1 Devices</p>
                                </div>
                                <mat.RaisedButton
                                    onClick={this.soloClick.bind(this)}
                                    label='SOLO'
                                    style={{ marginBottom: 8, }}
                                    primary={true}
                                    labelStyle={{ color: '#ffffff' }}
                                />

                            </mat.Card>
                        </div>
                        <div className='col-md-6 text-center box2'>
                            <mat.Card zDepth={1} >
                                <mat.Avatar
                                    src={multi}
                                    size={140}
                                    className='options'
                                    backgroundColor={'#ffffff'}
                                />
                                <div className="page-header text-center">
                                    <p style={{ fontSize: '3vh', fontFamily: 'arial', fontWeight: 'bold', color: '#abb8c3' }}>
                                        Team vs Team <br />
                                        Shared Devices
                                        </p>
                                </div>
                                <mat.RaisedButton
                                    onClick={this.teamClick.bind(this)}
                                    label='Team'
                                    style={{ marginBottom: 8, }}
                                    secondary={true}
                                    labelStyle={{ color: '#ffffff' }}
                                />
                            </mat.Card>
                        </div>
                    </div>
                    {/* </div> */}
                    <br />
                    <br />
                    <br />
                </mat.Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quizTitle: state.PlayReducers.playQuiz,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        singlePlayerAction: (action) => {
            dispatch(singlePlayerAction(action));
        },
        teamPlayersAction: (action) => {
            dispatch(teamPlayersAction(action))
        },
        // UnFavoriteQuizAction: (action, Allquiz) => {
        //     dispatch(UnFavoriteQuizAction(action, Allquiz))
        // },
        // PlayOptionsAction: (action) => {
        //     dispatch(PlayOptionsAction(action))
        // }

    };
}
export default connect(mapStateToProps, mapDispatchToProps)(PlayOptions);
// export default PlayOptions;


// WEBPACK FOOTER //
// ./src/component/play/playOptions.jsx